(function () {
  'use strict';

  function getSettings() {
    var section = document.querySelector('[data-section-id]');
    return {
      sidebarWidth: parseInt((section && section.dataset.sidebarWidth) || '260'),
      colsOpen:     parseInt((section && section.dataset.gridColsOpen)  || '2'),
      colsClosed:   parseInt((section && section.dataset.gridColsClosed) || '3'),
    };
  }

  /* ── Drawer sidebar ─────────────────────────────────── */
  function openDrawerFulldetail(modalId, index) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawerFulldetail(overlay) {
    if (!overlay) return;

    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initDrawerFulldetail() {
    /* OPEN */
    document.querySelectorAll('[data-modal]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
        var modalId = trigger.getAttribute('data-modal');
        var index   = parseInt(trigger.getAttribute('data-index'), 10);

        openDrawerFulldetail(modalId, index);
    });
    });

    /* CLOSE - overlay click */
    document.querySelectorAll('.l-fulldetail-modal-overlay').forEach(function (overlay) {
    overlay.addEventListener('click', function () {
        closeDrawerFulldetail(overlay);
    });
    });

    /* PREVENT CLOSE when clicking inside drawer */
    document.querySelectorAll('.l-fulldetail-modal').forEach(function (drawer) {
    drawer.addEventListener('click', function (e) {
        e.stopPropagation();
    });
    });

    /* CLOSE button */
    document.querySelectorAll('[data-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
          closeDrawerFulldetail(btn.closest('.l-fulldetail-modal-overlay'));
      });
    });

    /* ESC key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.l-fulldetail-modal-overlay.is-open')
          .forEach(closeDrawerFulldetail);
      }
    });
  }

  /* ── Sort select in topbar ───────────────────────────── */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-collection-sort]');
    if (!select) return;
    var collectionUrl = (document.querySelector('.collection-layout') || {}).dataset.collectionUrl || window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', select.value);
    params.delete('page');
    var url = collectionUrl + '?' + params.toString();
    history.pushState({}, '', url);
    if (typeof fetchFilteredProducts === 'function') {
      fetchFilteredProducts(url);
    } else {
      window.location.href = url;
    }
  });


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDrawerFulldetail();
    });
  } else {
    initDrawerFulldetail();
  }
})();
